import React from 'react'
import { withTranslation } from 'react-i18next'
import APPstyles from '@/App.less'
import styles from './index.less'

class Disclaimer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      
    }
  }
  render() {
    return (
      <div className={[APPstyles.flex_column,styles.disclaimer_con].join(' ')}>
        <div className={[APPstyles.flex_row,styles.oneCon].join(' ')}>
          <span>1.&nbsp;&nbsp;</span>
          <span>海外所得採「年度」方式計算，本公司係採「移動平均成本法」計算海外所得，查詢時請留意正確輸入查詢年度區間。</span>
        </div>
        <div className={[APPstyles.flex_row,styles.oneCon].join(' ')}>
          <span>2.&nbsp;&nbsp;</span>
          <span>按國稅局規定，證券商需協助提供客戶年度海外所得資料予國稅局，包含海外複委託之證券交易資本利得（科目為財產交易所得）、股票配息（科目為營利所得），基金、債券及境外結構型商品配息（科目為利息所得）。客戶只要符合前述三項科目個別或加總之年度海外所得金額超過50萬台幣，證券商就會提供相關資料予國稅局。</span>
        </div>
        <div className={[APPstyles.flex_row,styles.oneCon].join(' ')}>
          <span>3.&nbsp;&nbsp;</span>
          <span>其中證券交易資本利得（科目為財產交易所得）部分，本公司係採「移動平均成本法」來計算海外所得，並以客戶證券賣出交割日之所屬年度作為海外所得認定年度。故客戶須於本公司各海外股票市場之最後交易日當日或之前賣出庫存證券，才會計入當年度海外所得。因本公司採「移動平均成本法」來計算海外所得，請需留意如於年度海外股票所得最後交易日當日或之前又有新增之買進部位，則「移動平均成本」會再改變，亦會影響當年度海外所得的資料結果。</span>
        </div>
        <div className={[APPstyles.flex_row,styles.oneCon].join(' ')}>
          <span>4.&nbsp;&nbsp;</span>
          <span>本資料僅供參考，且依所得稅法規定，本公司因非海外所得之扣繳單位及申報義務人，提供國稅局的海外所得資料並非為客戶申報相關稅務的唯一依據。請需依個人實際海外所得情形，並依相關稅法規定向國稅局自行申報或列舉相關所得內容。</span>
        </div>
      </div>
    )
  }
}
export default withTranslation()(Disclaimer)